// syncfusion-l10n.service.ts
import { Injectable } from '@angular/core';
import { L10n } from '@syncfusion/ej2-base';

@Injectable({
  providedIn: 'root',
})
export class SyncfusionL10nService {
  constructor() {
    this.loadArabicTranslations();
  }

  private loadArabicTranslations() {
    L10n.load({
      ar: {
        grid: {
          // Toolbar
          Add: 'إضافة',
          Edit: 'تعديل',
          Delete: 'حذف',
          Update: 'تحديث',
          Cancel: 'إلغاء',
          Search: 'بحث',

          // Excel Filtering
          ExcelFilter: 'تصفية Excel',
          ClearFilter: 'مسح التصفية',
          Filter: 'تصفية',
          FilterButton: 'تصفية',
          ClearButton: 'مسح',
          NumberFilter: 'تصفية الأرقام',
          TextFilter: 'تصفية النصوص',
          DateFilter: 'تصفية التواريخ',
          MatchCase: 'مطابقة الحالة',
          SelectAll: 'تحديد الكل',

          // Filter Operators
          Equal: 'يساوي',
          NotEqual: 'لا يساوي',
          LessThan: 'أقل من',
          LessThanOrEqual: 'أقل من أو يساوي',
          GreaterThan: 'أكبر من',
          GreaterThanOrEqual: 'أكبر من أو يساوي',
          BeginsWith: 'يبدأ بـ',
          DoesNotBeginWith: 'لا يبدأ بـ',
          EndsWith: 'ينتهي بـ',
          DoesNotEndWith: 'لا ينتهي بـ',
          Contains: 'يحتوي على',
          DoesNotContain: 'لا يحتوي على',
          Between: 'بين',
          CustomFilter: 'تصفية مخصصة',

          // Sorting
          SortAscending: 'ترتيب تصاعدي',
          SortDescending: 'ترتيب تنازلي',
          SmallestToLargest: 'من الأصغر إلى الأكبر',
          LargestToSmallest: 'من الأكبر إلى الأصغر',
          AtoZ: 'من أ إلى ي',
          ZtoA: 'من ي إلى أ',

          // Action Buttons
          OKButton: 'موافق',
          CancelButton: 'إلغاء',

          // Misc
          ChooseDate: 'اختر تاريخًا',
          EnterValue: 'أدخل القيمة',
          NoResult: 'لا توجد نتائج',
          Blanks: 'فارغ',
          EmptyRecord: 'لا توجد بيانات للعرض',
        },

        pager: {
          currentPageInfo: 'صفحة {0} من {1}',
          totalItemsInfo: '({0} عنصرًا)',
          firstPageTooltip: 'الصفحة الأولى',
          lastPageTooltip: 'الصفحة الأخيرة',
          nextPageTooltip: 'الصفحة التالية',
          previousPageTooltip: 'الصفحة السابقة',
          nextPagerTooltip: 'الصفحات التالية',
          previousPagerTooltip: 'الصفحات السابقة',
          pagerDropDown: 'عدد العناصر في الصفحة',
          pagerAllDropDown: 'عرض الكل',
          all: 'الكل',
          pageSize: 'عدد العناصر في الصفحة',
        },
      },
    });
  }
}
